// extracted by mini-css-extract-plugin
export default {"root":"DocumentRow_root__D4soY","stack":"DocumentRow_stack__qa-tn","title":"DocumentRow_title__umFC6","icon":"DocumentRow_icon__ert5f","description":"DocumentRow_description__93n2W"};